/* eslint-disable max-len */
const CARS = [
  {
    id: 0,
    brand: "Mercedes-Benz",
    model: "W219",
    year: 2010,
    mileage: 280000,
    price: 53000,
    fuel: "Diesel",
    imageLogo: "https://i.ibb.co/crrX7tJ/mercedes-benz-logo.png",
    image1: "https://i.ibb.co/SvNYRkp/image122222-2.jpg",
    imageDetail1: "https://i.ibb.co/F0jY8yY/image4.jpg",
    imageDetail2: "https://i.ibb.co/sQCqWbz/image3.jpg",
    imageDetail3: "https://i.ibb.co/5FVs3Sz/image2.jpg",
    imageDetail4: "https://i.ibb.co/z7WQG8N/image1.jpg",
    imageDetail5: "https://i.ibb.co/ZgsMCLT/image5.jpg",
    power: 224,
    torque: 540,
    fuelConsumption: "9 l/100",
    displacement: 2987,
    cylinders: "6",
    color: "White",
    gearBox: "Automatic",
    gears: "7",
    driveChain: "Rear",
    feature1: "Rain sensor",
    feature2: "Xenon",
    feature3: "ABS",
    feature4: "Air conditioning",
    feature5: "Armrest",
    body: "Coupe",
    doors: "4",
    seats: "4",
    acceleration: "7",
    topSpeed: "246",
    height: "1403",
    length: "4913",
    wheelbase: "2854",
    width: "1873",
    description1:
      "The C219 Mercedes-Benz CLS-Class is the first generation of the CLS-Class zrange of four-door coupe.",
    description2:
      "The CLS-Class has only four seats and is marketed by Mercedes as a four-door coupé. For this reason, in Germany and in whole Europe the model code name is C219 while in US the CLS is more commonly named as W219 model. It was the first model globally to introduce this four-door coupe style and VW followed with the Volkswagen CC model in 2008.",
    description3:
      "The car is less practical than the W211 E-Class that it is based on, with less legroom, headroom, and boot space. The CLS-Class is priced above the E-Class, but below the S-Class in the Mercedes model range. It was replaced by the Mercedes-Benz CLS-Class (W218) in 2011.",
  },
  {
    id: 1,
    brand: "Mercedes-Benz",
    model: "W219",
    year: 2006,
    mileage: 290000,
    price: 32500,
    fuel: "Diesel",
    imageLogo: "https://i.ibb.co/crrX7tJ/mercedes-benz-logo.png",
    image1: "https://i.ibb.co/ypKqqrr/image-Mini.jpg",
    imageDetail1: "https://i.ibb.co/NKSsspP/image4-1.jpg",
    imageDetail2: "https://i.ibb.co/MD2BRLs/image5-1.jpg",
    imageDetail3: "https://i.ibb.co/27bw8Sq/image1-1.jpg",
    imageDetail4: "https://i.ibb.co/NVMhXYw/image2-1.jpg",
    imageDetail5: "https://i.ibb.co/PFmyZr9/image3-1.jpg",
    power: 224,
    torque: 540,
    fuelConsumption: "9 l/100",
    displacement: 2987,
    cylinders: "6",
    color: "Silver",
    gearBox: "Automatic",
    gears: "5",
    driveChain: "Rear",
    feature1: "Cruise control",
    feature2: "Lumbar support",
    feature3: "Xenon ",
    feature4: "Rain sensor",
    feature5: "Seat heating",
    body: "Coupe",
    doors: "4",
    seats: "4",
    acceleration: "7",
    topSpeed: "246",
    height: "1403",
    length: "4913",
    wheelbase: "2854",
    width: "1873",
    description1:
      "The C219 Mercedes-Benz CLS-Class is the first generation of the CLS-Class range of four-door coupe.",
    description2:
      "The CLS-Class has only four seats and is marketed by Mercedes as a four-door coupé. For this reason, in Germany and in whole Europe the model code name is C219 while in US the CLS is more commonly named as W219 model. It was the first model globally to introduce this four-door coupe style and VW followed with the Volkswagen CC model in 2008.",
    description3:
      "The car is less practical than the W211 E-Class that it is based on, with less legroom, headroom, and boot space. The CLS-Class is priced above the E-Class, but below the S-Class in the Mercedes model range. It was replaced by the Mercedes-Benz CLS-Class (W218) in 2011.",
  },
  {
    id: 2,
    brand: "Citroen",
    model: "C4",
    year: 2011,
    mileage: 111000,
    price: 23900,
    fuel: "Benzin",
    imageLogo: "https://i.ibb.co/yP760Sq/Citroen-Square-Logo.png",
    image1: "https://i.ibb.co/31SnvY0/image-Mini-1.jpg",
    imageDetail1: "https://i.ibb.co/35K3QMv/image4-2.jpg",
    imageDetail2: "https://i.ibb.co/ydf9Gmn/image5-2.jpg",
    imageDetail3: "https://i.ibb.co/P9j21Ng/image2-2.jpg",
    imageDetail4: "https://i.ibb.co/9wd0pKy/image3-2.jpg",
    imageDetail5: "https://i.ibb.co/HDsQgq9/image1-3.jpg",
    power: 120,
    torque: 210,
    fuelConsumption: "7,5 l/100",
    displacement: 1598,
    cylinders: "4",
    color: "Gray",
    gearBox: "Manual",
    gears: "6",
    driveChain: "Front",
    feature1: "Power windows",
    feature2: "Lumbar support",
    feature3: "Split rear seats",
    feature4: "Cruise control",
    feature5: "Armrest",
    body: "Hatchback",
    doors: "5",
    seats: "5",
    acceleration: "10",
    topSpeed: "195",
    height: "1458",
    length: "4274",
    wheelbase: "2608",
    width: "1769",
    description1:
      "The Citroën C4 is a compact car (C-segment in Europe) produced by French automaker Citroën since Autumn 2004. It is currently in its second generation.",
    description2:
      "The C4 was designed to be the successor to the Citroën Xsara. It is mechanically similar to the Peugeot 308, which was launched in 2007. A revised version, with a new front end, reverse lights, and dashboard revisions, was launched for the 2008/09 model year.",
    description3:
      "In January 2010, it was announced that the coupé version was not to be overhauled, but instead replaced with the Citroën DS4. The C4 scored second place at the 2005 European Car of the Year awards.",
  },
  {
    id: 3,
    brand: "Citroen",
    model: "C5",
    year: 2015,
    mileage: 107000,
    price: 56500,
    fuel: "Diesel",
    imageLogo: "https://i.ibb.co/yP760Sq/Citroen-Square-Logo.png",
    image1: "https://i.ibb.co/yVP7FJ0/image-Mini-2.jpg",
    imageDetail1: "https://i.ibb.co/mDbLDTN/image5-3.jpg",
    imageDetail2: "https://i.ibb.co/P1tR96Z/image4-3.jpg",
    imageDetail3: "https://i.ibb.co/WF56GjQ/image2-3.jpg",
    imageDetail4: "https://i.ibb.co/8KLdJc7/image3-3.jpg",
    imageDetail5: "https://i.ibb.co/tH4dMbp/image1-4.jpg",
    power: 163,
    torque: 340,
    fuelConsumption: "6 l/100",
    displacement: 1997,
    cylinders: "4",
    color: "Gray",
    gearBox: "Manual",
    gears: "6",
    driveChain: "Front",
    feature1: "Bluetooth",
    feature2: "Alloy wheels",
    feature3: "Navigation system",
    feature4: "Rain sensor",
    feature5: "Cruise control",
    body: "Kombi",
    doors: "5",
    seats: "5",
    acceleration: "9.1",
    topSpeed: "210",
    height: "1558",
    length: "4979",
    wheelbase: "2708",
    width: "1867",
    description1:
      "The second generation C5 was officially unveiled in May 2006, and does not retain the hatchback body style, instead being a regular, three box saloon of an aerodynamic shape.",
    description2:
      " However, this second generation is often criticised, especially by core Citroën fans, for its German like exterior design, which makes it look more like a German saloon, than a French one.",
    description3:
      "The C5 Airscape, which was presented at the Frankfurt Motor Show in September 2007, gave an outlook on the second generation C5.",
  },
  {
    id: 4,
    brand: "Citroen",
    model: "C5",
    year: 2013,
    mileage: 76000,
    price: 44900,
    fuel: "Diesel",
    imageLogo: "https://i.ibb.co/yP760Sq/Citroen-Square-Logo.png",
    image1: "https://i.ibb.co/yFPJ2rF/image-Mini-3.jpg",
    imageDetail1: "https://i.ibb.co/wSKZJMJ/image3-4.jpg",
    imageDetail2: "https://i.ibb.co/jW8xDq7/image4-4.jpg",
    imageDetail3: "https://i.ibb.co/hFYyPdV/image2-4.jpg",
    imageDetail4: "https://i.ibb.co/Fmc6y4b/image1-5.jpg",
    imageDetail5: "https://i.ibb.co/nQmdRVH/image-1.jpg",
    power: 163,
    torque: 340,
    fuelConsumption: "5,5 l/100",
    displacement: 1997,
    cylinders: "4",
    color: "Black",
    gearBox: "Manual",
    gears: "6",
    driveChain: "Front",
    feature1: "Tuner TV",
    feature2: "MP3",
    feature3: "CD",
    feature4: "LED",
    feature5: "Navigation system",
    body: "Sedan",
    doors: "5",
    seats: "5",
    acceleration: "9.0",
    topSpeed: "212",
    height: "1557",
    length: "4776",
    wheelbase: "2708",
    width: "1867",
    description1:
      "The second generation C5 was officially unveiled in May 2006, and does not retain the hatchback body style, instead being a regular, three box saloon of an aerodynamic shape.",
    description2:
      " However, this second generation is often criticised, especially by core Citroën fans, for its German like exterior design, which makes it look more like a German saloon, than a French one.",
    description3:
      "The C5 Airscape, which was presented at the Frankfurt Motor Show in September 2007, gave an outlook on the second generation C5.",
  },
  {
    id: 5,
    brand: "Citroen",
    model: "C6",
    year: 2007,
    mileage: 260000,
    price: 17800,
    fuel: "Diesel",
    imageLogo: "https://i.ibb.co/yP760Sq/Citroen-Square-Logo.png",
    image1: "https://i.ibb.co/rGNsLpv/image-Mini-4.jpg",
    imageDetail1: "https://i.ibb.co/1zL1S1M/image5-4.jpg",
    imageDetail2: "https://i.ibb.co/r0b60BX/image1-6.jpg",
    imageDetail3: "https://i.ibb.co/wMzyLsv/image2-5.jpg",
    imageDetail4: "https://i.ibb.co/vDZ5R6j/image4-5.jpg",
    imageDetail5: "https://i.ibb.co/6FgHNWc/image3-5.jpg",
    power: 170,
    tourqe: 360,
    fuelConsumption: "8 l/100",
    displacement: 2179,
    cylinders: "4",
    color: "Black",
    gearBox: "Manual",
    gears: "6",
    driveChain: "Front",
    feature1: "Air conditioning",
    feature2: "Heads-up display",
    feature3: "CD player",
    feature4: "Seat heating",
    feature5: "Ski bag",
    body: "Fastback",
    doors: "4",
    seats: "5",
    acceleration: "9.1",
    topSpeed: "212",
    height: "1558",
    length: "4989",
    wheelbase: "2878",
    width: "1961",
    description1:
      "The Citroën C6 is an executive car produced by the French car maker Citroën from 2005 to 2012. The Citroën C6 was inspired by the Citroën C6 Lignage concept car with a fastback saloon like styling.",
    description2:
      "Inspired by the Citroën C6 Lignage prototype, which was first shown at the Geneva Motor Show in the spring of 1999, but differs from the concept car's styling in minor details (like not having rear suicide doors for easy access). The C6 was intended as a replacement for the XM, and Citroën was intent on launching it before the end of 2000.",
    description3:
      "At the time, it was hoped that the C6 would go into production by the end of 2000, as the replacement for the ageing XM, which was first produced in May 1989.",
  },
  {
    id: 6,
    brand: "Citroen",
    model: "C6",
    year: 2011,
    mileage: 277343,
    price: 28800,
    fuel: "Diesel",
    imageLogo: "https://i.ibb.co/yP760Sq/Citroen-Square-Logo.png",
    image1: "https://i.ibb.co/rmXdvMv/image-Mini-2.png",
    imageDetail1: "https://i.ibb.co/GtPXXMR/image5-5.jpg",
    imageDetail2: "https://i.ibb.co/Jp1PWMt/image4-6.jpg",
    imageDetail3: "https://i.ibb.co/34b4MHW/image2-1.png",
    imageDetail4: "https://i.ibb.co/njPqyMK/image3-6.jpg",
    imageDetail5: "https://i.ibb.co/4Sf9zcV/image1-2.png",
    power: 241,
    tourqe: 400,
    fuelConsumption: "10 l/100",
    displacement: 2992,
    cylinders: "6",
    color: "Silver",
    gearBox: "Automatic",
    gears: "6",
    driveChain: "Front",
    feature1: "Cruise control",
    feature2: "Xenon",
    feature3: "Rain sensor",
    feature4: "Isofix",
    feature5: "Adaptive headlights",
    body: "Fastback",
    doors: "4",
    seats: "5",
    acceleration: "9.1",
    topSpeed: "212",
    height: "1558",
    length: "4989",
    wheelbase: "2878",
    width: "1961",
    description1:
      "The Citroën C6 is an executive car produced by the French car maker Citroën from 2005 to 2012. The Citroën C6 was inspired by the Citroën C6 Lignage concept car with a fastback saloon like styling.",
    description2:
      "Inspired by the Citroën C6 Lignage prototype, which was first shown at the Geneva Motor Show in the spring of 1999, but differs from the concept car's styling in minor details (like not having rear suicide doors for easy access). The C6 was intended as a replacement for the XM, and Citroën was intent on launching it before the end of 2000.",
    description3:
      "At the time, it was hoped that the C6 would go into production by the end of 2000, as the replacement for the ageing XM, which was first produced in May 1989.",
  },
  {
    id: 7,
    brand: "Citroen",
    model: "C4",
    year: 2011,
    mileage: 144542,
    price: 26600,
    fuel: "Benzin",
    imageLogo: "https://i.ibb.co/yP760Sq/Citroen-Square-Logo.png",
    image1: "https://i.ibb.co/cgBh7D6/image-Mini-5.jpg",
    imageDetail1: "https://i.ibb.co/0X6cdLw/image1-7.jpg",
    imageDetail2: "https://i.ibb.co/tDmDM74/image3-7.jpg",
    imageDetail3: "https://i.ibb.co/SJ8RG1F/image2-6.jpg",
    imageDetail4: "https://i.ibb.co/YZbKY3H/image5-6.jpg",
    imageDetail5: "https://i.ibb.co/Bt6y2mc/image4-7.jpg",
    power: 156,
    torque: 260,
    fuelConsumption: "8 l/100",
    displacement: 1600,
    cylinders: "4",
    color: "Gray",
    gearBox: "Manual",
    gears: "6",
    driveChain: "Front",
    feature1: "AUX",
    feature2: "ESP",
    feature3: "CD",
    feature4: "Cruise control",
    feature5: "Bluetooth",
    body: "Hatchback",
    doors: "5",
    seats: "5",
    acceleration: "10",
    topSpeed: "195",
    height: "1458",
    length: "4274",
    wheelbase: "2608",
    width: "1769",
    description1:
      "The Citroën C4 is a compact car (C-segment in Europe) produced by French automaker Citroën since Autumn 2004. It is currently in its second generation.",
    description2:
      "The C4 was designed to be the successor to the Citroën Xsara. It is mechanically similar to the Peugeot 308, which was launched in 2007. A revised version, with a new front end, reverse lights, and dashboard revisions, was launched for the 2008/09 model year.",
    description3:
      "In January 2010, it was announced that the coupé version was not to be overhauled, but instead replaced with the Citroën DS4. The C4 scored second place at the 2005 European Car of the Year awards.",
  },
  {
    id: 8,
    brand: "Citroen",
    model: "Saxo",
    year: 2000,
    mileage: 245542,
    price: 4000,
    fuel: "Benzin/LPG",
    imageLogo: "https://i.ibb.co/yP760Sq/Citroen-Square-Logo.png",
    image1: "https://i.ibb.co/r2DMvJW/image-Mini-6.jpg",
    imageDetail1: "https://i.ibb.co/s3y0KM7/image5-7.jpg",
    imageDetail2: "https://i.ibb.co/VD4QNpX/image3-8.jpg",
    imageDetail3: "https://i.ibb.co/RjGMMYC/image4-8.jpg",
    imageDetail4: "https://i.ibb.co/02dzbkk/image2-7.jpg",
    imageDetail5: "https://i.ibb.co/6NSQbKq/image1-8.jpg",
    power: 75,
    torque: 113,
    fuelConsumption: "7 l/100",
    displacement: 1360,
    cylinders: "4",
    color: "Silver",
    gearBox: "Manual",
    gears: "5",
    driveChain: "Front",
    feature1: "ABS",
    feature2: "Power steering",
    feature3: "Passenger airbag",
    feature4: "Central lock",
    feature5: "CD",
    body: "Hatchback",
    doors: "3",
    seats: "5",
    acceleration: "12.9",
    topSpeed: "175",
    height: "1360",
    length: "3718",
    wheelbase: "2385",
    width: "1595",
    description1:
      "The Citroën Saxo was a supermini produced by the French manufacturer Citroën from 1996 to 2004.",
    description2:
      "It was sold in Japan as the Citroën Chanson, because Honda had registered the Saxo name. It shared many engine and body parts with the Peugeot 106 (which itself was a development of the Citroën AX), the major difference being interiors and body panels.",
    description3:
      "Production ended in 2004, when it was replaced with the Citroën C2 and Citroën C3.",
  },
  {
    id: 9,
    brand: "Citroen",
    model: "Saxo",
    year: 2003,
    mileage: 185400,
    price: 4999,
    fuel: "Benzin",
    imageLogo: "https://i.ibb.co/yP760Sq/Citroen-Square-Logo.png",
    image1: "https://i.ibb.co/YXL7M9n/image-Mini-7.jpg",
    imageDetail1: "https://i.ibb.co/QnzT09w/image5-8.jpg",
    imageDetail2: "https://i.ibb.co/W21CLf4/image4-9.jpg",
    imageDetail3: "https://i.ibb.co/bBpBHmp/image2-8.jpg",
    imageDetail4: "https://i.ibb.co/Mc4932n/image3-9.jpg",
    imageDetail5: "https://i.ibb.co/bNyLXQ0/image1-9.jpg",
    power: 75,
    torque: 113,
    fuelConsumption: "7 l/100",
    displacement: 1360,
    cylinders: "4",
    color: "Red",
    gearBox: "Manual",
    gears: "5",
    driveChain: "Front",
    feature1: "Electric windows",
    feature2: "CD",
    feature3: "Passenger airbag",
    feature4: "Power steering",
    feature5: "ABS",
    body: "Hatchback",
    doors: "3",
    seats: "5",
    acceleration: "12.9",
    topSpeed: "175",
    height: "1360",
    length: "3718",
    wheelbase: "2385",
    width: "1595",
    description1:
      "The Citroën Saxo was a supermini produced by the French manufacturer Citroën from 1996 to 2004.",
    description2:
      "It was sold in Japan as the Citroën Chanson, because Honda had registered the Saxo name. It shared many engine and body parts with the Peugeot 106 (which itself was a development of the Citroën AX), the major difference being interiors and body panels.",
    description3:
      "Production ended in 2004, when it was replaced with the Citroën C2 and Citroën C3.",
  },
  {
    id: 10,
    brand: "Citroen",
    model: "Saxo",
    year: 2002,
    mileage: 175400,
    price: 3200,
    fuel: "Benzin",
    imageLogo: "https://i.ibb.co/yP760Sq/Citroen-Square-Logo.png",
    image1: "https://i.ibb.co/84zRj87/image-Mini-8.jpg",
    imageDetail1: "https://i.ibb.co/jfNyS27/image5-9.jpg",
    imageDetail2: "https://i.ibb.co/zxtJ3sf/image3-10.jpg",
    imageDetail3: "https://i.ibb.co/dkzZTqD/image2-9.jpg",
    imageDetail4: "https://i.ibb.co/ng9GTsQ/image4-10.jpg",
    imageDetail5: "https://i.ibb.co/GTnKvgz/image1-10.jpg",
    power: 60,
    torque: 88,
    fuelConsumption: "6 l/100",
    displacement: 1124,
    cylinders: "4",
    color: "Silver",
    gearBox: "Manual",
    gears: "5",
    driveChain: "Front",
    feature1: "Power steering",
    feature2: "CD",
    feature3: "ABS",
    feature4: "Central lock",
    feature5: "Airbag",
    body: "Hatchback",
    doors: "3",
    seats: "5",
    acceleration: "15.3",
    topSpeed: "162",
    height: "1360",
    length: "3718",
    wheelbase: "2385",
    width: "1595",
    description1:
      "The Citroën Saxo was a supermini produced by the French manufacturer Citroën from 1996 to 2004.",
    description2:
      "It was sold in Japan as the Citroën Chanson, because Honda had registered the Saxo name. It shared many engine and body parts with the Peugeot 106 (which itself was a development of the Citroën AX), the major difference being interiors and body panels.",
    description3:
      "Production ended in 2004, when it was replaced with the Citroën C2 and Citroën C3.",
  },
  {
    id: 11,
    brand: "Citroen",
    model: "C5",
    year: 2016,
    mileage: 107000,
    price: 39900,
    fuel: "Diesel",
    imageLogo: "https://i.ibb.co/yP760Sq/Citroen-Square-Logo.png",
    image1: "https://i.ibb.co/9G86ZbB/image-Mini-9.jpg",
    imageDetail1: "https://i.ibb.co/gw32pz4/image5-10.jpg",
    imageDetail2: "https://i.ibb.co/0jGFWfr/image4-11.jpg",
    imageDetail3: "https://i.ibb.co/Mf9Tmtt/image3-11.jpg",
    imageDetail4: "https://i.ibb.co/xYMyrQ7/image2-10.jpg",
    imageDetail5: "https://i.ibb.co/D5BJQwM/image1-11.jpg",
    power: 150,
    torque: 340,
    fuelConsumption: "6 l/100",
    displacement: 1997,
    cylinders: "4",
    color: "Gray",
    gearBox: "Manual",
    gears: "6",
    driveChain: "Front",
    feature1: "LED",
    feature2: "ASR",
    feature3: "GPS",
    feature4: "Rain sensor",
    feature5: "Cruise control",
    body: "Kombi",
    doors: "5",
    seats: "5",
    acceleration: "9.5",
    topSpeed: "202",
    height: "1558",
    length: "4979",
    wheelbase: "2708",
    width: "1867",
    description1:
      "The second generation C5 was officially unveiled in May 2006, and does not retain the hatchback body style, instead being a regular, three box saloon of an aerodynamic shape.",
    description2:
      "However, this second generation is often criticised, especially by core Citroën fans, for its German like exterior design, which makes it look more like a German saloon, than a French one.",
    description3:
      "The C5 Airscape, which was presented at the Frankfurt Motor Show in September 2007, gave an outlook on the second generation C5.",
  },
  {
    id: 12,
    brand: "Citroen",
    model: "C3",
    year: 2007,
    mileage: 91000,
    price: 13600,
    fuel: "Benzin",
    imageLogo: "https://i.ibb.co/yP760Sq/Citroen-Square-Logo.png",
    image1: "https://i.ibb.co/9TLGvjd/Bez-tytu-u.jpg",
    imageDetail1: "https://i.ibb.co/pz246Xk/image5-11.jpg",
    imageDetail2: "https://i.ibb.co/cXWMFFf/image4-12.jpg",
    imageDetail3: "https://i.ibb.co/L98B09M/image3-12.jpg",
    imageDetail4: "https://i.ibb.co/k9CPvjL/image2-11.jpg",
    imageDetail5: "https://i.ibb.co/rMMLwzv/image1-12.jpg",
    power: 110,
    torque: 131,
    fuelConsumption: "8 l/100",
    displacement: 1600,
    cylinders: "4",
    color: "Gray",
    gearBox: "Automatic",
    gears: "6",
    driveChain: "Front",
    feature1: "Central lock",
    feature2: "ESP",
    feature3: "AUX",
    feature4: "LED",
    feature5: "Bluetooth",
    body: "Hatchback",
    doors: "5",
    seats: "5",
    acceleration: "11",
    topSpeed: "165",
    height: "1428",
    length: "3974",
    wheelbase: "2508",
    width: "1669",
    description1:
      "The Citroën C3 is a supermini car produced by Citroën since April 2002.",
    description2:
      "It replaced the Citroën Saxo in the model line up, and is currently in its third generation. The third generation model made its appearance in June 2016, and went on sale in January 2017.",
    description3:
      "A three door hatchback, with a similar design as the second generation, marketed as a premium model, is available as the DS3.",
  },
  {
    id: 13,
    brand: "Citroen",
    model: "C3",
    year: 2011,
    mileage: 171000,
    price: 16800,
    fuel: "Diesel",
    imageLogo: "https://i.ibb.co/yP760Sq/Citroen-Square-Logo.png",
    image1: "https://i.ibb.co/QXnS9XQ/image-Mini-10.jpg",
    imageDetail1: "https://i.ibb.co/cYsgCCy/image5-12.jpg",
    imageDetail2: "https://i.ibb.co/WVh4Gsd/image4-13.jpg",
    imageDetail3: "https://i.ibb.co/34Y82zy/image3-13.jpg",
    imageDetail4: "https://i.ibb.co/SN4twXb/image2-12.jpg",
    imageDetail5: "https://i.ibb.co/ZdDKtMt/image1-13.jpg",
    power: 68,
    torque: 160,
    fuelConsumption: "5 l/100",
    displacement: 1398,
    cylinders: "4",
    color: "Black",
    gearBox: "Manual",
    gears: "5",
    driveChain: "Front",
    feature1: "CD",
    feature2: "Cruise control",
    feature3: "ASR",
    feature4: "LED",
    feature5: "Electric mirrors",
    body: "Hatchback",
    doors: "5",
    seats: "5",
    acceleration: "13.7",
    topSpeed: "163",
    height: "1428",
    length: "3974",
    wheelbase: "2508",
    width: "1669",
    description1:
      "The Citroën C3 is a supermini car produced by Citroën since April 2002.",
    description2:
      "It replaced the Citroën Saxo in the model line up, and is currently in its third generation. The third generation model made its appearance in June 2016, and went on sale in January 2017.",
    description3:
      "A three door hatchback, with a similar design as the second generation, marketed as a premium model, is available as the DS3.",
  },
  {
    id: 14,
    brand: "Mercedes-Benz",
    model: "W204",
    year: 2011,
    mileage: 69000,
    price: 49700,
    fuel: "Benzin",
    imageLogo: "https://i.ibb.co/crrX7tJ/mercedes-benz-logo.png",
    image1: "https://i.ibb.co/HdkrqBp/Bez-tytu-u-1.jpg",
    imageDetail1: "https://i.ibb.co/DG3DS91/image5-13.jpg",
    imageDetail2: "https://i.ibb.co/2F9cf24/image3-14.jpg",
    imageDetail3: "https://i.ibb.co/nBLCJgs/image2-13.jpg",
    imageDetail4: "https://i.ibb.co/PGydPQk/image1-15.jpg",
    imageDetail5: "https://i.ibb.co/FmsFBKy/image4-15.jpg",
    power: 156,
    torque: 270,
    fuelConsumption: "8,5 l/100",
    displacement: 1796,
    cylinders: "4",
    color: "Blue",
    gearBox: "Manual",
    gears: "6",
    driveChain: "Rear",
    feature1: "AUX",
    feature2: "Parking sensors",
    feature3: "Xenon ",
    feature4: "Isofix",
    feature5: "GPS",
    body: "Sedan",
    doors: "4",
    seats: "5",
    acceleration: "9",
    topSpeed: "220",
    height: "1423",
    length: "4713",
    wheelbase: "2684",
    width: "1823",
    description1:
      "The Mercedes-Benz C-Class (W204) is the third generation Mercedes-Benz C-Class a range of compact executive cars ",
    description2:
      "Sub-models included the C 200 Kompressor, the C 230, the C 280, the C 350, the C 220 CDI, and the C 320 CDI. The C 180 Kompressor, C 230, and C 200 CDI were available in the beginning of August 2007. The W204 station wagon was not marketed in North America.",
    description3:
      "Production reached over 2.4 million worldwide, and the W204 was the brand's best selling vehicle at the time.",
  },
  {
    id: 15,
    brand: "Mercedes-Benz",
    model: "W204",
    year: 2011,
    mileage: 350000,
    price: 27700,
    fuel: "Diesel",
    imageLogo: "https://i.ibb.co/crrX7tJ/mercedes-benz-logo.png",
    image1: "https://i.ibb.co/GCvtcjM/Bez-tytu-u-2.jpg",
    imageDetail1: "https://i.ibb.co/cr1NBcB/image5-14.jpg",
    imageDetail2: "https://i.ibb.co/wMg0zfc/image4-16.jpg",
    imageDetail3: "https://i.ibb.co/s5GjJfS/image1-16.jpg",
    imageDetail4: "https://i.ibb.co/QcSFHMc/image3-15.jpg",
    imageDetail5: "https://i.ibb.co/hWg755L/image2-14.jpg",
    power: 136,
    torque: 310,
    fuelConsumption: "7,5 l/100",
    displacement: 2200,
    cylinders: "4",
    color: "Black",
    gearBox: "Manual",
    gears: "6",
    driveChain: "Rear",
    feature1: "CD",
    feature2: "ABS",
    feature3: "Xenon ",
    feature4: "ESP",
    feature5: "GPS",
    body: "Kombi",
    doors: "5",
    seats: "5",
    acceleration: "11,5",
    topSpeed: "190",
    height: "1523",
    length: "4812",
    wheelbase: "2694",
    width: "1821",
    description1:
      "The Mercedes-Benz C-Class (W204) is the third generation Mercedes-Benz C-Class a range of compact executive cars ",
    description2:
      "Sub-models included the C 200 Kompressor, the C 230, the C 280, the C 350, the C 220 CDI, and the C 320 CDI. The C 180 Kompressor, C 230, and C 200 CDI were available in the beginning of August 2007. The W204 station wagon was not marketed in North America.",
    description3:
      "Production reached over 2.4 million worldwide, and the W204 was the brand's best selling vehicle at the time.",
  },
  {
    id: 16,
    brand: "Mercedes-Benz",
    model: "W204",
    year: 2007,
    mileage: 115000,
    price: 39900,
    fuel: "Benzin",
    imageLogo: "https://i.ibb.co/crrX7tJ/mercedes-benz-logo.png",
    image1: "https://i.ibb.co/q5kVgqG/mini.jpg",
    imageDetail1: "https://i.ibb.co/rmLBTYJ/4.jpg",
    imageDetail2: "https://i.ibb.co/Y2R7w7b/3.jpg",
    imageDetail3: "https://i.ibb.co/1mfbTgq/5.jpg",
    imageDetail4: "https://i.ibb.co/M8r64Dv/1-1.jpg",
    imageDetail5: "https://i.ibb.co/GQHbkqm/2.jpg",
    power: 156,
    torque: 270,
    fuelConsumption: "8,5 l/100",
    displacement: 1796,
    cylinders: "4",
    color: "Beige",
    gearBox: "Manual",
    gears: "6",
    driveChain: "Rear",
    feature1: "Bluetooth",
    feature2: "ESP",
    feature3: "Xenon ",
    feature4: "Isofix",
    feature5: "ABS",
    body: "Sedan",
    doors: "4",
    seats: "5",
    acceleration: "9",
    topSpeed: "220",
    height: "1423",
    length: "4713",
    wheelbase: "2684",
    width: "1823",
    description1:
      "The Mercedes-Benz C-Class (W204) is the third generation Mercedes-Benz C-Class a range of compact executive cars ",
    description2:
      "Sub-models included the C 200 Kompressor, the C 230, the C 280, the C 350, the C 220 CDI, and the C 320 CDI. The C 180 Kompressor, C 230, and C 200 CDI were available in the beginning of August 2007. The W204 station wagon was not marketed in North America.",
    description3:
      "Production reached over 2.4 million worldwide, and the W204 was the brand's best selling vehicle at the time.",
  },
  {
    id: 17,
    brand: "Mercedes-Benz",
    model: "W211",
    year: 2007,
    mileage: 297000,
    price: 23900,
    fuel: "Diesel",
    imageLogo: "https://i.ibb.co/crrX7tJ/mercedes-benz-logo.png",
    image1: "https://i.ibb.co/K5Cjtkm/Bez-tytu-u-3.jpg",
    imageDetail1: "https://i.ibb.co/hfXSfbT/image5-15.jpg",
    imageDetail2: "https://i.ibb.co/SNGXPFN/image3-16.jpg",
    imageDetail3: "https://i.ibb.co/3YmVgN1/1-2.jpg",
    imageDetail4: "https://i.ibb.co/NKrsw0F/image4-17.jpg",
    imageDetail5: "https://i.ibb.co/jfbJnYL/image2-15.jpg",
    power: 170,
    torque: 320,
    fuelConsumption: "7 l/100",
    displacement: 2200,
    cylinders: "4",
    color: "Black",
    gearBox: "Automatic",
    gears: "5",
    driveChain: "Rear",
    feature1: "Cruise control",
    feature2: "ESP",
    feature3: "Bluetooth ",
    feature4: "GPS",
    feature5: "LED",
    body: "Kombi",
    doors: "5",
    seats: "5",
    acceleration: "9,8",
    topSpeed: "212",
    height: "1523",
    length: "4923",
    wheelbase: "2694",
    width: "1843",
    description1:
      "The W211-based C219 CLS-Class sedan was introduced as a niche model in 2005, primarily to attract a younger demographic.",
    description2:
      "The W211 E-Class was facelifted in June 2006 for the 2007 model year to address quality and technical issues raised by earlier models, Sensotronic was dropped, while Pre-Safe (w/o brake support) was made standard.",
    description3:
      "The largest factory built engine in the E-class range is the E500 (badged E550 in the U.S.) which had its engine size increased from 5 litres to 5.5 litres in 2006 along with the facelift. ",
  },
  {
    id: 18,
    brand: "Mercedes-Benz",
    model: "W211",
    year: 2007,
    mileage: 277000,
    price: 26900,
    fuel: "Diesel",
    imageLogo: "https://i.ibb.co/crrX7tJ/mercedes-benz-logo.png",
    image1: "https://i.ibb.co/DKX5zYv/Bez-tytu-u-4.jpg",
    imageDetail1: "https://i.ibb.co/5LrVBdZ/image5-16.jpg",
    imageDetail2: "https://i.ibb.co/Bw8jdvf/image4-18.jpg",
    imageDetail3: "https://i.ibb.co/cJTyjMj/image3-17.jpg",
    imageDetail4: "https://i.ibb.co/M2jrX6h/image6.jpg",
    imageDetail5: "https://i.ibb.co/NmB8rWm/1-3.jpg",
    power: 170,
    torque: 320,
    fuelConsumption: "7 l/100",
    displacement: 2200,
    cylinders: "4",
    color: "Silver",
    gearBox: "Automatic",
    gears: "5",
    driveChain: "Rear",
    feature1: "Cruise control",
    feature2: "Xenon",
    feature3: "Bluetooth ",
    feature4: "AUX",
    feature5: "GPS",
    body: "Sedan",
    doors: "4",
    seats: "5",
    acceleration: "9,6",
    topSpeed: "215",
    height: "1523",
    length: "4823",
    wheelbase: "2694",
    width: "1843",
    description1:
      "The W211-based C219 CLS-Class sedan was introduced as a niche model in 2005, primarily to attract a younger demographic.",
    description2:
      "The W211 E-Class was facelifted in June 2006 for the 2007 model year to address quality and technical issues raised by earlier models, Sensotronic was dropped, while Pre-Safe (w/o brake support) was made standard.",
    description3:
      "The largest factory built engine in the E-class range is the E500 (badged E550 in the U.S.) which had its engine size increased from 5 litres to 5.5 litres in 2006 along with the facelift. ",
  },
  {
    id: 19,
    brand: "Mercedes-Benz",
    model: "W211",
    year: 2007,
    mileage: 142000,
    price: 34900,
    fuel: "Benzin",
    imageLogo: "https://i.ibb.co/crrX7tJ/mercedes-benz-logo.png",
    image1: "https://i.ibb.co/C00K6HV/Bez-tytu-u-5.jpg",
    imageDetail1: "https://i.ibb.co/KDkk7W5/image5-17.jpg",
    imageDetail2: "https://i.ibb.co/jZFK48f/image4-19.jpg",
    imageDetail3: "https://i.ibb.co/9vPcS35/image3-18.jpg",
    imageDetail4: "https://i.ibb.co/1qjmB7C/image1-17.jpg",
    imageDetail5: "https://i.ibb.co/WW19XZ1/image22.jpg",
    power: 231,
    torque: 310,
    fuelConsumption: "7 l/100",
    displacement: 2996,
    cylinders: "6",
    color: "Silver",
    gearBox: "Automatic",
    gears: "5",
    driveChain: "Rear",
    feature1: "Xenon",
    feature2: "Power steering",
    feature3: "CD",
    feature4: "Alarm",
    feature5: "ABS",
    body: "Sedan",
    doors: "4",
    seats: "5",
    acceleration: "7,5",
    topSpeed: "231",
    height: "1523",
    length: "4723",
    wheelbase: "2634",
    width: "1823",
    description1:
      "The W211-based C219 CLS-Class sedan was introduced as a niche model in 2005, primarily to attract a younger demographic.",
    description2:
      "The W211 E-Class was facelifted in June 2006 for the 2007 model year to address quality and technical issues raised by earlier models, Sensotronic was dropped, while Pre-Safe (w/o brake support) was made standard.",
    description3:
      "The largest factory built engine in the E-class range is the E500 (badged E550 in the U.S.) which had its engine size increased from 5 litres to 5.5 litres in 2006 along with the facelift. ",
  },
  {
    id: 20,
    brand: "Mercedes-Benz",
    model: "W221",
    year: 2015,
    mileage: 141000,
    price: 122998,
    fuel: "Diesel",
    imageLogo: "https://i.ibb.co/crrX7tJ/mercedes-benz-logo.png",
    image1: "https://i.ibb.co/mvTw8Xm/Bez-tytu-u-6.jpg",
    imageDetail1: "https://i.ibb.co/3h0trCn/5-1.jpg",
    imageDetail2: "https://i.ibb.co/Jsz5SN4/image1-18.jpg",
    imageDetail3: "https://i.ibb.co/5LR6rg7/image2-16.jpg",
    imageDetail4: "https://i.ibb.co/pnH1c7J/image3-19.jpg",
    imageDetail5: "https://i.ibb.co/nQJ6ygc/image4-20.jpg",
    power: 258,
    torque: 410,
    fuelConsumption: "8 l/100",
    displacement: 2996,
    cylinders: "6",
    color: "Black",
    gearBox: "Automatic",
    gears: "7",
    driveChain: "Rear",
    feature1: "DVD",
    feature2: "MP3",
    feature3: "Tuner TV",
    feature4: "Alarm",
    feature5: "AUX",
    body: "Sedan",
    doors: "4",
    seats: "4",
    acceleration: "8",
    topSpeed: "211",
    height: "1622",
    length: "5023",
    wheelbase: "2624",
    width: "1821",
    description1:
      "The Mercedes-Benz W221 is a chassis code of S-Class, the successor of the Mercedes-Benz S-Class (W220).",
    description2:
      "The S-Class are the flagship vehicles of Mercedes-Benz and each generation typically introduces a range of technical innovations and developments that over time will find their way into smaller cars",
    description3: "The vehicle was unveiled at the 2005 Frankfurt Motor Show.",
  },
  {
    id: 21,
    brand: "Mercedes-Benz",
    model: "W221",
    year: 2007,
    mileage: 350000,
    price: 57000,
    fuel: "Benzin",
    imageLogo: "https://i.ibb.co/crrX7tJ/mercedes-benz-logo.png",
    image1: "https://i.ibb.co/kxnsQWL/Bez-tytu-u-8.jpg",
    imageDetail1: "https://i.ibb.co/nf5qv1T/image2-17.jpg",
    imageDetail2: "https://i.ibb.co/X5hF0ck/image3-20.jpg",
    imageDetail3: "https://i.ibb.co/PGCTJP7/image1-19.jpg",
    imageDetail4: "https://i.ibb.co/W5Fjwpj/image4-21.jpg",
    imageDetail5: "https://i.ibb.co/br4LzXn/image5-18.jpg",
    power: 388,
    torque: 410,
    fuelConsumption: "8 l/100",
    displacement: 5461,
    cylinders: "8",
    color: "Black",
    gearBox: "Automatic",
    gears: "7",
    driveChain: "4x4",
    feature1: "Parking sensors",
    feature2: "MP3",
    feature3: "Backup camera",
    feature4: "Alarm",
    feature5: "Heated seats",
    body: "Sedan",
    doors: "4",
    seats: "4",
    acceleration: "6",
    topSpeed: "250",
    height: "1622",
    length: "5023",
    wheelbase: "2624",
    width: "1821",
    description1:
      "The Mercedes-Benz W221 is a chassis code of S-Class, the successor of the Mercedes-Benz S-Class (W220).",
    description2:
      "The S-Class are the flagship vehicles of Mercedes-Benz and each generation typically introduces a range of technical innovations and developments that over time will find their way into smaller cars",
    description3: "The vehicle was unveiled at the 2005 Frankfurt Motor Show.",
  },
  {
    id: 22,
    brand: "Mercedes-Benz",
    model: "W221",
    year: 2014,
    mileage: 76000,
    price: 199500,
    fuel: "Benzin",
    imageLogo: "https://i.ibb.co/crrX7tJ/mercedes-benz-logo.png",
    image1: "https://i.ibb.co/02693KG/Bez-tytu-u-9.jpg",
    imageDetail1: "https://i.ibb.co/2j37T7B/image5-19.jpg",
    imageDetail2: "https://i.ibb.co/6YTBb1G/image3-21.jpg",
    imageDetail3: "https://i.ibb.co/svx5x6t/image4-22.jpg",
    imageDetail4: "https://i.ibb.co/jVd1mVF/image2-18.jpg",
    imageDetail5: "https://i.ibb.co/NpdczCC/image1-20.jpg",
    power: 458,
    torque: 600,
    fuelConsumption: "8 l/100",
    displacement: 5461,
    cylinders: "8",
    color: "White",
    gearBox: "Automatic",
    gears: "7",
    driveChain: "Rear",
    feature1: "Rain sensor",
    feature2: "GPS",
    feature3: "Backup camera",
    feature4: "LED",
    feature5: "Heated seats",
    body: "Sedan",
    doors: "4",
    seats: "4",
    acceleration: "4,5",
    topSpeed: "250",
    height: "1622",
    length: "5023",
    wheelbase: "2624",
    width: "1821",
    description1:
      "The Mercedes-Benz W221 is a chassis code of S-Class, the successor of the Mercedes-Benz S-Class (W220).",
    description2:
      "The S-Class are the flagship vehicles of Mercedes-Benz and each generation typically introduces a range of technical innovations and developments that over time will find their way into smaller cars",
    description3: "The vehicle was unveiled at the 2005 Frankfurt Motor Show.",
  },
  {
    id: 23,
    brand: "BMW",
    model: "F31",
    year: 2016,
    mileage: 183000,
    price: 62000,
    fuel: "Diesel",
    imageLogo: "https://i.ibb.co/FXrS5wN/bmw-logo.jpg",
    image1: "https://i.ibb.co/6mRqs92/Bez-tytu-u-10.jpg",
    imageDetail1: "https://i.ibb.co/cCy2vBf/image4-23.jpg",
    imageDetail2: "https://i.ibb.co/2M2vh98/image5-20.jpg",
    imageDetail3: "https://i.ibb.co/XjQjLsq/image2-19.jpg",
    imageDetail4: "https://i.ibb.co/rmjPfBY/image3-22.jpg",
    imageDetail5: "https://i.ibb.co/PZWNfvJ/image1-21.jpg",
    power: 163,
    torque: 400,
    fuelConsumption: "6 l/100",
    displacement: 1995,
    cylinders: "4",
    color: "Gray",
    gearBox: "Automatic",
    gears: "8",
    driveChain: "Rear",
    feature1: "LED",
    feature2: "USB",
    feature3: "Backup camera",
    feature4: "LED",
    feature5: "Cruise control",
    body: "Kombi",
    doors: "5",
    seats: "5",
    acceleration: "8,2",
    topSpeed: "222",
    height: "1416",
    length: "4633",
    wheelbase: "2810",
    width: "1811",
    description1:
      "The sixth generation of the BMW 3 Series consists of the BMW F30 (sedan version), BMW F31 (wagon version, marketed as 'Touring') and BMW F34 (fastback version, marketed as 'Gran Turismo') compact executive cars. ",
    description2:
      "For the sixth generation, the coupé and convertible models were spun off to create the new BMW 4 Series nameplate. BMW also introduced a separate hatchback model under the 3 Series nameplate called the '3 Series Gran Turismo'.",
    description3:
      "The F30 is the first generation of 3 Series to be powered by a range of turbocharged engines exclusively and electric power steering (replacing the hydraulic power steering systems used previously).",
  },
  {
    id: 24,
    brand: "BMW",
    model: "F30",
    year: 2013,
    mileage: 222000,
    price: 54000,
    fuel: "Diesel",
    imageLogo: "https://i.ibb.co/FXrS5wN/bmw-logo.jpg",
    image1: "https://i.ibb.co/mcRChTz/Bez-tytu-u-11.jpg",
    imageDetail1: "https://i.ibb.co/CWJJnVF/image1-22.jpg",
    imageDetail2: "https://i.ibb.co/0mPQB35/image4-24.jpg",
    imageDetail3: "https://i.ibb.co/JpskrNf/image2-20.jpg",
    imageDetail4: "https://i.ibb.co/tK7L2cV/image3-23.jpg",
    imageDetail5: "https://i.ibb.co/CWJJnVF/image1-22.jpg",
    power: 184,
    torque: 420,
    fuelConsumption: "6,5 l/100",
    displacement: 1995,
    cylinders: "4",
    color: "Black",
    gearBox: "Manual",
    gears: "6",
    driveChain: "4x4",
    feature1: "Xenon",
    feature2: "USB",
    feature3: "Cruise control",
    feature4: "LED",
    feature5: "Backup camera",
    body: "Sedan",
    doors: "4",
    seats: "5",
    acceleration: "8,0",
    topSpeed: "225",
    height: "1416",
    length: "4533",
    wheelbase: "2810",
    width: "1811",
    description1:
      "The sixth generation of the BMW 3 Series consists of the BMW F30 (sedan version), BMW F31 (wagon version, marketed as 'Touring') and BMW F34 (fastback version, marketed as 'Gran Turismo') compact executive cars. ",
    description2:
      "For the sixth generation, the coupé and convertible models were spun off to create the new BMW 4 Series nameplate. BMW also introduced a separate hatchback model under the 3 Series nameplate called the '3 Series Gran Turismo'.",
    description3:
      "The F30 is the first generation of 3 Series to be powered by a range of turbocharged engines exclusively and electric power steering (replacing the hydraulic power steering systems used previously).",
  },
  {
    id: 25,
    brand: "BMW",
    model: "F31",
    year: 2015,
    mileage: 95000,
    price: 59000,
    fuel: "Diesel",
    imageLogo: "https://i.ibb.co/FXrS5wN/bmw-logo.jpg",
    image1: "https://i.ibb.co/89DvtbN/Bez-tytu-u-12.jpg",
    imageDetail1: "https://i.ibb.co/RgG3dsT/image3-24.jpg",
    imageDetail2: "https://i.ibb.co/Bwh1jyt/image4-25.jpg",
    imageDetail3: "https://i.ibb.co/JyLLCwb/image2-21.jpg",
    imageDetail4: "https://i.ibb.co/cwZdtGn/image5-22.jpg",
    imageDetail5: "https://i.ibb.co/k6p46ZV/image1-23.jpg",
    power: 163,
    torque: 400,
    fuelConsumption: "6 l/100",
    displacement: 1995,
    cylinders: "4",
    color: "Black",
    gearBox: "Automatic",
    gears: "8",
    driveChain: "Rear",
    feature1: "Bluetooth",
    feature2: "USB",
    feature3: "Heated seats",
    feature4: "LED",
    feature5: "USB",
    body: "Kombi",
    doors: "5",
    seats: "5",
    acceleration: "8,2",
    topSpeed: "222",
    height: "1416",
    length: "4633",
    wheelbase: "2810",
    width: "1811",
    description1:
      "The sixth generation of the BMW 3 Series consists of the BMW F30 (sedan version), BMW F31 (wagon version, marketed as 'Touring') and BMW F34 (fastback version, marketed as 'Gran Turismo') compact executive cars. ",
    description2:
      "For the sixth generation, the coupé and convertible models were spun off to create the new BMW 4 Series nameplate. BMW also introduced a separate hatchback model under the 3 Series nameplate called the '3 Series Gran Turismo'.",
    description3:
      "The F30 is the first generation of 3 Series to be powered by a range of turbocharged engines exclusively and electric power steering (replacing the hydraulic power steering systems used previously).",
  },
  {
    id: 26,
    brand: "BMW",
    model: "F11",
    year: 2012,
    mileage: 295000,
    price: 59500,
    fuel: "Benzin",
    imageLogo: "https://i.ibb.co/FXrS5wN/bmw-logo.jpg",
    image1: "https://i.ibb.co/R2qf55F/Bez-tytu-u-13.jpg",
    imageDetail1: "https://i.ibb.co/F5SywjX/image5-23.jpg",
    imageDetail2: "https://i.ibb.co/qpZWWgb/image4-26.jpg",
    imageDetail3: "https://i.ibb.co/b5HwRgR/image1-24.jpg",
    imageDetail4: "https://i.ibb.co/6gGRPRx/image2-22.jpg",
    imageDetail5: "https://i.ibb.co/849h8Dx/image3-25.jpg",
    power: 245,
    torque: 350,
    fuelConsumption: "9 l/100",
    displacement: 1995,
    cylinders: "4",
    color: "Black",
    gearBox: "Automatic",
    gears: "8",
    driveChain: "Rear",
    feature1: "Backup camera",
    feature2: "LED",
    feature3: "Heated seats",
    feature4: "Xenon",
    feature5: "USB",
    body: "Kombi",
    doors: "5",
    seats: "5",
    acceleration: "8,2",
    topSpeed: "222",
    height: "1416",
    length: "4633",
    wheelbase: "2810",
    width: "1811",
    description1:
      "The sixth generation of the BMW 5 Series consists of the BMW F10 (sedan version), BMW F11 (wagon version, marketed as 'Touring').",
    description2:
      "The F10 generation is also the first 5 Series to offer a hybrid drivetrain, a forced induction V8 engine, an 8-speed automatic transmission, a dual-clutch transmission (in the M5), active rear-wheel steering (called 'Integral Active Steering'), electric power steering, double-wishbone front suspension, an LCD instrument cluster (called 'Black Panel Display') and automatic parking (called 'Parking Assistant').",
    description3:
      "In February 2017, the BMW 5 Series (G30) launched as the successor to the F10.",
  },
  {
    id: 27,
    brand: "BMW",
    model: "F11",
    year: 2012,
    mileage: 247000,
    price: 58500,
    fuel: "Diesel",
    imageLogo: "https://i.ibb.co/FXrS5wN/bmw-logo.jpg",
    image1: "https://i.ibb.co/QCm5s01/Bez-tytu-u-14.jpg",
    imageDetail1: "https://i.ibb.co/BZkGqgk/image2-23.jpg",
    imageDetail2: "https://i.ibb.co/LSL9mwv/image4-27.jpg",
    imageDetail3: "https://i.ibb.co/ZdH88W9/image3-26.jpg",
    imageDetail4: "https://i.ibb.co/BZkGqgk/image2-23.jpg",
    imageDetail5: "https://i.ibb.co/LSL9mwv/image4-27.jpg",
    power: 218,
    torque: 360,
    fuelConsumption: "7,5 l/100",
    displacement: 1995,
    cylinders: "4",
    color: "White",
    gearBox: "Automatic",
    gears: "8",
    driveChain: "4x4",
    feature1: "AUX",
    feature2: "LED",
    feature3: "Tinted windows",
    feature4: "Cruise control",
    feature5: "CD",
    body: "Kombi",
    doors: "5",
    seats: "5",
    acceleration: "8,7",
    topSpeed: "218",
    height: "1416",
    length: "4733",
    wheelbase: "2820",
    width: "1821",
    description1:
      "The sixth generation of the BMW 5 Series consists of the BMW F10 (sedan version), BMW F11 (wagon version, marketed as 'Touring').",
    description2:
      "The F10 generation is also the first 5 Series to offer a hybrid drivetrain, a forced induction V8 engine, an 8-speed automatic transmission, a dual-clutch transmission (in the M5), active rear-wheel steering (called 'Integral Active Steering'), electric power steering, double-wishbone front suspension, an LCD instrument cluster (called 'Black Panel Display') and automatic parking (called 'Parking Assistant').",
    description3:
      "In February 2017, the BMW 5 Series (G30) launched as the successor to the F10.",
  },
  {
    id: 28,
    brand: "Dodge",
    model: "Charger",
    year: 2012,
    mileage: 247000,
    price: 58500,
    fuel: "Benzin/LPG",
    imageLogo: "https://i.ibb.co/KGPgJzx/111.png",
    image1: "https://i.ibb.co/7NzvBWy/Bez-tytu-u.png",
    imageDetail1: "https://i.ibb.co/GQtRZ7d/1.png",
    imageDetail2: "https://i.ibb.co/pKL82WK/2.png",
    imageDetail3: "https://i.ibb.co/GMwgwyn/image3.png",
    imageDetail4: "https://i.ibb.co/bRqVdzp/image4.png",
    imageDetail5: "https://i.ibb.co/MhCn2Mx/image5.png",
    power: 385,
    torque: 440,
    fuelConsumption: "15 l/100",
    displacement: 5654,
    cylinders: "8",
    color: "White",
    gearBox: "Automatic",
    gears: "8",
    driveChain: "Rear",
    feature1: "Electric mirrors",
    feature2: "Power steering",
    feature3: "Tinted windows",
    feature4: "Cruise control",
    feature5: "ABS",
    body: "Sedan",
    doors: "4",
    seats: "5",
    acceleration: "5,7",
    topSpeed: "250",
    height: "1416",
    length: "4833",
    wheelbase: "2810",
    width: "1823",
    description1:
      "The Dodge Charger is a model of automobile marketed by Dodge.",
    description2:
      "There have been several different production variants of Chargers, built on three different platforms and sizes. In the United States, the Charger nameplate has been used on subcompact hatchbacks, full-size sedans, muscle cars, and personal luxury coupes. The current version is a four-door sedan.",
    description3:
      "Dodge reintroduced the Charger in 2005 for the 2006 model year in a new form.[5] This generation was available only as a four-door sedan using the Chrysler LX platform The design was intended to be reminiscent of the Chargers of the 1960s and 1970s and the taillights harkened back to that era, as did the new stamped hood and side panels.",
  },
  {
    id: 29,
    brand: "Dodge",
    model: "Charger",
    year: 2012,
    mileage: 147000,
    price: 70500,
    fuel: "Benzin/LPG",
    imageLogo: "https://i.ibb.co/KGPgJzx/111.png",
    image1: "https://i.ibb.co/7pmjqj6/1111.png",
    imageDetail1: "https://i.ibb.co/89jFZYj/image13.png",
    imageDetail2: "https://i.ibb.co/M6W6zyK/image12.png",
    imageDetail3: "https://i.ibb.co/4mtRLxv/image11.png",
    imageDetail4: "https://i.ibb.co/ThxpKXC/image14.png",
    imageDetail5: "https://i.ibb.co/WKZy5Hb/image1111.png",
    power: 375,
    torque: 430,
    fuelConsumption: "12 l/100",
    displacement: 5654,
    cylinders: "8",
    color: "Gray",
    gearBox: "Automatic",
    gears: "8",
    driveChain: "Rear",
    feature1: "Bluetooth",
    feature2: "AUX",
    feature3: "USB",
    feature4: "Xenon",
    feature5: "ABS",
    body: "Sedan",
    doors: "4",
    seats: "5",
    acceleration: "5,9",
    topSpeed: "250",
    height: "1416",
    length: "4833",
    wheelbase: "2810",
    width: "1823",
    description1:
      "The Dodge Charger is a model of automobile marketed by Dodge.",
    description2:
      "There have been several different production variants of Chargers, built on three different platforms and sizes. In the United States, the Charger nameplate has been used on subcompact hatchbacks, full-size sedans, muscle cars, and personal luxury coupes. The current version is a four-door sedan.",
    description3:
      "In addition, a new heated steering wheel featuring Chrysler's new paddle shifter system, new sport seats, and a 900 watt Harman Kardon audio system became available.",
  },
  {
    id: 30,
    brand: "Dodge",
    model: "Challenger",
    year: 2015,
    mileage: 147000,
    price: 119900,
    fuel: "Benzin",
    imageLogo: "https://i.ibb.co/KGPgJzx/111.png",
    image1: "https://i.ibb.co/Srxhr6g/Bez-tytu-u.png",
    imageDetail1: "https://i.ibb.co/TmxwykY/1.jpg",
    imageDetail2: "https://i.ibb.co/3p6TmfD/image2.png",
    imageDetail3: "https://i.ibb.co/wWNpjdW/image3.png",
    imageDetail4: "https://i.ibb.co/Pz6zD3q/image4.png",
    imageDetail5: "https://i.ibb.co/Hqhn2rw/image5.png",
    power: 380,
    torque: 500,
    fuelConsumption: "17 l/100",
    displacement: 5700,
    cylinders: "8",
    color: "Red",
    gearBox: "Manual",
    gears: "6",
    driveChain: "Rear",
    feature1: "Bluetooth",
    feature2: "AUX",
    feature3: "USB",
    feature4: "Xenon",
    feature5: "ABS",
    body: "Coupe",
    doors: "2",
    seats: "5",
    acceleration: "5,5",
    topSpeed: "250",
    height: "1416",
    length: "4933",
    wheelbase: "2820",
    width: "1821",
    description1:
      "The base SE trim was renamed to SXT for consistency with the naming scheme of the remaining Dodge lineup.",
    description2:
      "The SRT8 392 model gains a two-mode adaptive suspension system which features an Auto and Sport mode. The car uses a variety of sensors to measure inputs like vehicle speed, steering angle, brake torque, throttle position and acceleration forces to instantly tune the suspension for the given condition depending on what mode is chosen.",
    description3:
      "Dodge reintroduced the Charger in 2005 for the 2006 model year in a new form.[5] This generation was available only as a four-door sedan using the Chrysler LX platform The design was intended to be reminiscent of the Chargers of the 1960s and 1970s and the taillights harkened back to that era, as did the new stamped hood and side panels. ",
  },
];
export default CARS;
